import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

const CustomSnackbar = ({ open, message, severity, onClose }) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={onClose}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
        >
            <Alert onClose={onClose} severity={severity}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {message}
                </Typography>
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar;
